import {mock} from "../../conf/context";
import ajax from "../../lib/appfuse-react/core/ajax";

const trafficInfoService = {
    find: async () => {
        const response = await ajax.get("classLocationTransportations")
        return response.data;
    }
}

export default trafficInfoService;